import { Fragment, ReactNode, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { CustomModalContext } from "../../../contexts/CustomModalContext";
import { Box, Typography /*, useMediaQuery, useTheme*/ } from "@mui/material";

type CustomModalProps = {
    title: string;
    children: ReactNode;
};

export default function CustomModal({ children, title }: CustomModalProps) {
    const { updateIsCustomModalActive, isCustomModalActive, modal } =
        useContext(CustomModalContext);

    //const theme = useTheme();
    //const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const { sx, disableBackdropClick } = modal;

    const handleClose = (event: any, reason: string) => {
        if (reason === "backdropClick" && disableBackdropClick) return;
        updateIsCustomModalActive(false);
    };

    return (
        <Fragment>
            <Dialog
                // fullScreen={fullScreen}
                open={isCustomModalActive}
                onClose={handleClose}
                maxWidth={"md"}
                sx={{
                    ".MuiDialog-container": {
                        "@media (max-width:1024px)": {
                            height: "105%",
                            alignItems: "end",
                            "@media (min-width:600px)": {
                                alignItems: "end",
                            },
                        },
                    },

                    ".MuiDialog-paper": {
                        display: "flex",
                        padding: "4rem",
                        alignItems: "flex-start",
                        gap: "0.625rem",
                        borderRadius: "1.5rem",
                        background: "#FFF",
                        height: "fit-content",
                        flexShrink: 0,
                        position: "relative",
                        overflowX: "hidden",
                        boxSizing: "border-box",
                        ...sx?.paper,
                        ...sx,
                        "@media (max-width:1024px)": {
                            width: "100%",
                            padding: "2rem 1.5rem 1.25rem 1.5rem",
                            borderRadius: "1.5rem 1.5rem 0rem 0rem",
                        },
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "2rem",
                        flex: "1 0 0",

                        width: "100%",

                        padding: 0,
                    }}
                >
                    {title ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "0.5rem",
                                alignSelf: "stretch",
                                width: "100%",
                                padding: 0,
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#023",
                                    fontFamily: "Roboto",
                                    fontSize: "1.25rem",
                                    fontStyle: "normal",
                                    fontWeight: "700",
                                    lineHeight: "normal",
                                }}
                            >
                                {title}
                            </Typography>
                        </Box>
                    ) : null}
                    <DialogContent
                        sx={{
                            width: "100%",
                            padding: 0,
                            // "@media (max-width:1024px)": {
                            //     padding: "2rem",
                            // },
                        }}
                    >
                        {children}
                    </DialogContent>
                </Box>
            </Dialog>
        </Fragment>
    );
}
